import { Injectable } from '@angular/core';
import { TranslateUtil } from './translate.util';
import { MessageService } from 'primeng/api';
import { ERROR_MESSAGES } from '../constant/error-messages.constant';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NotificationUtil {
  constructor(
    private readonly translateUtil: TranslateUtil,
    private readonly messageService: MessageService
  ) {}

  public success(
    text: string,
    params: Params = {},
    title = 'COMMON.SUCCESS',
    key = 'global'
  ) {
    const translations = this.translateUtil.translate([text, title], params);

    this.messageService.add({
      key,
      severity: 'success',
      summary: translations[title],
      detail: translations[text],
    });
  }

  public info(
    text: string,
    params: Params = {},
    title = 'COMMON.INFO',
    key = 'global'
  ) {
    const translations = this.translateUtil.translate([text, title], params);

    this.messageService.add({
      key,
      severity: 'info',
      summary: translations[title],
      detail: translations[text],
    });
  }

  public warning(
    text: string,
    params: Params = {},
    title = 'COMMON.WARNING',
    key = 'global'
  ) {
    const translations = this.translateUtil.translate([text, title], params);

    this.messageService.add({
      key,
      severity: 'warning',
      summary: translations[title],
      detail: translations[text],
    });
  }

  public error(
    text: string,
    params: Params = {},
    title = 'COMMON.ERROR',
    key = 'global'
  ) {
    const translations = this.translateUtil.translate([text, title], params);

    this.messageService.add({
      key,
      severity: 'error',
      summary: translations[title],
      detail: translations[text],
    });
  }

  public showGeneralError(key = 'global') {
    this.error(ERROR_MESSAGES.GENERAL.GENERAL_ERROR, {}, 'COMMON.ERROR', key);
  }

  public removeAll(key: string) {
    this.messageService.clear(key);
  }
}
